module.exports = __webpack_public_path__ + "static/img/103052.6d6a9f98.png";